<template>
  <div class="czzn-cwbb">
    <div class="czsc-con">
      <p>平台“财务报表”包括：资产负债表、利润表、现金流量表，利润表和现金流量表支持按月、季、年进行查询。</p>
      <div class="czsc-nr-tit">【资产负债表】</div>
      <p>资产负债表是总括反映企业一定日期（月末、季末或年末）全部资产、负债和所有者权益情况的会计报表。它是以日常会计核算记录的数据为基础进行归类、整理和汇总，加工成报表项目的过程。它反映了企业在某一特定日期所拥有或控制的经济来源，所承担的现时义务和所有者对净资产的要求权。</p>
      <p>报表公式是设置好的，用户只需要录入凭证后，系统会自动生成报表数据。</p>
      <img src="@/assets/images/czzn_056.png" />
      <p>具体操作：</p>
      <p><span class="czsc-nr-ct">步骤 1 </span> 在工作台中，将鼠标放在左侧“财务报表”模块，点击“资产负债表”，进入“资产负债表”页面。</p>
      <p><span class="czsc-nr-ct">步骤 2 </span> 在“资产负债表”页面中，设置查询的会计期间。</p>
      <p><span class="czsc-nr-ct">步骤 3 </span> 在资产负债表页面，您可以执行以下操作：</p>
      <div class="czsc-nr-ct-box">如何打印资产负债表</div>
      <p>点击“打印”按钮，直接进入资产负债表打印预览页面，您可以单击打印机图标进行打印设置。</p>
      <div class="czsc-nr-ct-box">如何导出资产负债表</div>
      <p>点击“导出”按钮，左下方出现 Excel 表格，直接打开查看或者保存至本地。</p>
      <div class="czsc-nr-hsbj-box">
        <p>说明：</p>
        <p>点击资产负债表项目可以修改报表公式。</p>
      </div>
      <div class="czsc-nr-tit">【利润表】</div>
      <p>利润表是总括反映企业在一定时期（年度、季度或月份）利润（或亏损）的实际形成情况的会计报表。利润表按照各项收入、费用以及构成利润各个项目分类分项编制而成的。本系统提供多步式利润表。</p>
      <p>平台提供月度、季度和年度利润表。</p>
      <img src="@/assets/images/czzn_057.png" />
      <p>具体操作：</p>
      <p><span class="czsc-nr-ct">步骤 1 </span>在工作台中，将鼠标放在左侧“财务报表”模块，点击“利润表”，进入“利润表”页面。</p>
      <p><span class="czsc-nr-ct">步骤 2 </span>在“利润表”页面中，设置查询的会计期间。</p>
      <p><span class="czsc-nr-ct">步骤 3 </span>在利润表页面，您可以执行以下操作：</p>
      <div class="czsc-nr-ct-box">如何打印利润表</div>
      <p>点击“打印”按钮，直接进入利润表打印预览页面，您可以单击打印机图标进行打印设置。</p>
      <div class="czsc-nr-ct-box">如何导出利润表</div>
      <p>点击“导出”按钮，左下方出现 Excel 表格，直接打开查看或者保存至本地。</p>
      <div class="czsc-nr-tit">【现金流量表】</div>
      <p>现金流量表是综合反映企业一定会计期间内现金来源、运用及增减变动情况的报表。</p>
      <p>平台提供月度、年度现金流量表，无需指定，数据自动生成。</p>
      <img src="@/assets/images/czzn_058.png" />
      <p>具体操作：</p>
      <p><span class="czsc-nr-ct">步骤 1 </span>在系统主界面中，将鼠标放在左侧“财务报表”模块，点击“现金流量表”，进入“现金流量表”页面。</p>
      <p><span class="czsc-nr-ct">步骤 2 </span>在“现金流量表”页面中，设置查询的会计期间。</p>
      <p><span class="czsc-nr-ct">步骤 3 </span>在现金流量表页面，您可以执行以下操作：</p>
      <div class="czsc-nr-ct-box">如何打印现金流量表</div>
      <p>点击“打印”按钮，直接进入现金流量表打印预览页面，您可以点击打印机图标进行打印设置。</p>
      <div class="czsc-nr-ct-box">如何导出现金流量表</div>
      <p>点击“导出”按钮，左下方出现 Excel 表格，直接打开查看或者保存至本地。</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'czzn_cwbb',
};
</script>
